// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"732":"b96d1950","842":"aea158e9"}[chunkId] + ".chunk.css";
};